import tzlookup from "tz-lookup"

export const getTimeZone = (lat?: string | null, long?: string | null) =>
  tzlookup(parseFloat(lat || "0"), parseFloat(long || "0"))
